export enum EFormatTextType {
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  Strikethrough = 'strikethrough',
  OrderedList = 'ordered-list',
  BulletList = 'bullet-list',
}
